import './header.scss';

import React from 'react';

import { IndexLink } from 'react-router';

import Grid from 'components/grid';
import Column from 'components/column';
import Search from 'components/search';
import Menu from 'components/menu';
import Dropdown from 'components/dropdown';

export default (props) => (
  <header className="page-header">
    <Grid>
      <Column width={2}>
        <IndexLink to="/">Home</IndexLink>
      </Column>
      <Column width={6}>
        <Search query={props.query} />
      </Column>
      <Column width={4}>
        <Menu items={[
          {href: '/sizes', title: 'Sizes'},
          ]}
        />
      </Column>
    </Grid>
  </header>
);

/*
<Dropdown title="Account">
          <p>Hello</p>
        </Dropdown>*/



/** WEBPACK FOOTER **
 ** ./components/header/index.js
 **/